var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{staticClass:"logo z50 pointer",attrs:{"to":"/","tag":"div"}},[_c('div',{staticClass:"inner"},[_c('img',{staticClass:"img z10",attrs:{"src":"/static/assets/alle/Logo.png"}}),_vm._v(" "),_c('img',{staticClass:"imgbg rotating z9",attrs:{"src":"/static/assets/alle/Logo_Shine.png"}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2cef9030","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Toplogo.vue
// module id = null
// module chunks = 